// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2W_-v","left":"styles_left__3miI8"};